export default "__VITE_ASSET__DaY6LAHC__"